import { Link } from 'react-router'
import styled from 'styled-components'
import textsData from '@/textData/SignupFormTexts.json'
import { useUserLanguage } from '@/customHooks/useUserLanguage'
import { SignupForm } from '../organism'
import { pathURL } from '@/components/constants/urls'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  padding-top: ${({ theme }) => theme.spacing.lg};
  padding-bottom: ${({ theme }) => theme.spacing.lg};
`
const StyledText = styled.div`
  text-align: center;
  width: 300px;
  & > h1 {
    color: black;
  }
  & > p {
    word-wrap: normal;
  }
`
export const SignupUserTemplate = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  return (
    <Wrapper>
      <StyledText>
        <h1>{texts.title}</h1>
        <p>
          {texts.paragraph}
        </p>
      </StyledText>
      
      <SignupForm />
      
      <div>
        <p>{texts.back.text} <Link to={`/${pathURL.LOGIN}`}>{texts.back.linkText}</Link></p>
      </div>
    </Wrapper>  
  )
}